import { render, staticRenderFns } from "./PatientMlrDetails.vue?vue&type=template&id=01d6da8c"
import script from "./PatientMlrDetails.vue?vue&type=script&lang=js"
export * from "./PatientMlrDetails.vue?vue&type=script&lang=js"
import style0 from "./PatientMlrDetails.vue?vue&type=style&index=0&id=01d6da8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports